import { Button, Stack, TextInput } from '@mantine/core';
import { modals } from '@mantine/modals';
import { useState } from 'react';

type Props = {
  initialValue?: string;
  label: string;
  onSubmit: (name: string) => Promise<void> | void;
  submitLabel: string;
};

const FolderNameModal = ({ initialValue = '', label, onSubmit, submitLabel }: Props) => {
  const [name, setName] = useState(initialValue);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async () => {
    const trimmedName = name.trim();

    if (!trimmedName) {
      return;
    }

    setIsSubmitting(true);

    try {
      await onSubmit(trimmedName);
      modals.closeAll();
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Stack gap="md">
      <TextInput
        label={label}
        value={name}
        onChange={event => setName(event.currentTarget.value)}
        autoFocus
        data-autofocus
      />
      <Button onClick={handleSubmit} loading={isSubmitting} disabled={!name.trim()}>
        {submitLabel}
      </Button>
    </Stack>
  );
};

export default FolderNameModal;
